import React from "react";
import Select from "react-select";
import { countries } from "country-data";
import { Control, Controller } from "react-hook-form";
import { useThemeColors } from "../../../Store/modules/theme";
import { useLanguage } from "../../../Store/modules/language";

const options = countries.all
  .map((i) => ({
    value: i.countryCallingCodes[0],
    label: i.countryCallingCodes[0],
  }))
  .filter(Boolean)
  .filter((i) => i.label);

export type CountryCodeProps = {
  control: Control<any>;
};
export const CountryCode: React.FC<CountryCodeProps> = (props) => {
  const { control } = props;
  const [colors] = useThemeColors();
  const { locale } = useLanguage();
  const [theme] = useThemeColors();

  const customStyles = {
    option: (provided: any) => ({
      ...provided,
      fontSize: "14px",
      direction: "ltr",
      textAlign: "center",
      padding: "8px 12px",
    }),
    singleValue: (provided: any) => ({
      ...provided,
      textAlign: "center",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      color: theme.text,
    }),
    control: (e: any) => ({
      ...e,
      width: "45px",
      backgroundColor: "transparent",
      fontSize: "14px",
      direction: "ltr",
      height: 45,
      outline: "none",
      borderTopWidth: 0,
      borderLeftWidth: 0,
      borderBottomWidth: 0,
      borderRightWidth: 1,
      borderRightColor: colors.optBorderInput,
      boxShadow: "none",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      whiteSpace: "nowrap",
      fontFamily: locale === "en" ? "Mulish, Estedad" : "Estedad, Mulish",
    }),
    menu: (provided: any) => ({
      ...provided,
      minWidth: "120px",
      width: "auto",
      position: "absolute",
      zIndex: 9999,
      left: 0,
      right: "auto",
      color: theme.text,
      backgroundColor: theme.secondary,
      fontFamily: locale === "en" ? "Mulish, Estedad" : "Estedad, Mulish",
    }),
    menuList: (provided: any) => ({
      ...provided,
      minWidth: "120px",
      maxHeight: "200px",
      fontFamily: locale === "en" ? "Mulish, Estedad" : "Estedad, Mulish",
    }),
    menuPortal: (provided: any) => ({
      ...provided,
      zIndex: 9999,
    }),
    dropdownIndicator: () => ({
      display: "none",
    }),
    indicatorSeparator: () => ({
      display: "none",
    }),
  };
  // Get default country code based on locale
  const getDefaultCountryCode = () => {
    if (locale === "en") {
      return {
        label: countries?.US?.countryCallingCodes[0] || "+1",
        value: countries?.US?.countryCallingCodes[0] || "+1",
      };
    } else {
      return {
        label: countries?.IR?.countryCallingCodes[0] || "+98",
        value: countries?.IR?.countryCallingCodes[0] || "+98",
      };
    }
  };

  const getDefaultValue = () => {
    if (locale === "en") {
      return "1";
    } else {
      return "98";
    }
  };

  return (
    <Controller
      control={control}
      defaultValue={getDefaultValue()}
      render={({ field: { onChange } }) => (
        <Select
          defaultValue={getDefaultCountryCode()}
          options={options}
          onChange={(item) => onChange(item?.value.replace("+", ""))}
          placeholder=""
          styles={customStyles}
          theme={(myTheme) => ({
            ...myTheme,
            colors: {
              ...myTheme.colors,
              primary25: theme.primary,
            },
          })}
          components={{
            IndicatorSeparator: () => null,
            DropdownIndicator: () => null,
          }}
          menuPortalTarget={document.body}
          menuPosition="fixed"
        />
      )}
      name="country_code"
    />
  );
};
